// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sider[data-v-8de50dac] {\n  overflow: auto;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n}\n.logo__container[data-v-8de50dac] {\n  width: 100%;\n  margin: 0 auto;\n  padding: 2rem 0rem;\n  text-align: center;\n}\n.menu-search[data-v-8de50dac] {\n  margin: 0 1rem 1rem;\n  width: calc(100% - 2rem);\n}\n.empty-state[data-v-8de50dac] {\n  margin-top: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
